import type { ReactElement } from "react";
import { useRef } from "react";

import { CSSTransition, SwitchTransition } from "react-transition-group";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { SIWizardSmallLogoUrl } from "app/pages/sales-intelligence/constants/images";
import { IS_LEGACY_USER_PENDING_ACTIVATION } from "app/pages/sales-intelligence/modules/onboarding";
import { PreferencesService } from "app/services/preferences/preferencesService";

import {
    StyledAnimatedDescription,
    StyledOnboardingDescription,
    StyledOnboardingGreetingText,
    StyledOnboardingLeftPartContainer,
    StyledSITitleText,
    StyledWelcomeText,
} from "./styles";

const SI_LOGO_SEPARATOR = "%siLogoPlace%";

const OnboardingLeftPartContainer = (): ReactElement => {
    const welcomeTitle = translate("si.onboarding.wizard.welcome-to-text").split(SI_LOGO_SEPARATOR);

    const nodeRef = useRef(null);

    const isLegacyUser = !!PreferencesService.get(IS_LEGACY_USER_PENDING_ACTIVATION);

    return (
        <StyledOnboardingLeftPartContainer>
            <StyledWelcomeText>
                <span dangerouslySetInnerHTML={{ __html: welcomeTitle[0] }} />

                <img src={SIWizardSmallLogoUrl} />

                <StyledSITitleText dangerouslySetInnerHTML={{ __html: welcomeTitle[1] }} />
            </StyledWelcomeText>

            <I18n
                translatable={{ key: "si.onboarding.left-part.greating-text.title" }}
                element={StyledOnboardingGreetingText}
            />

            <SwitchTransition>
                <CSSTransition
                    key="description"
                    in
                    mountOnEnter={false}
                    timeout={500}
                    classNames="item"
                    nodeRef={nodeRef}
                >
                    <StyledAnimatedDescription ref={nodeRef}>
                        <I18n
                            translatable={{
                                key: `si.onboarding.left-part.greating-text.${isLegacyUser ? "existing" : "new"}-user.description`,
                            }}
                            element={StyledOnboardingDescription}
                        />
                    </StyledAnimatedDescription>
                </CSSTransition>
            </SwitchTransition>
        </StyledOnboardingLeftPartContainer>
    );
};

export default OnboardingLeftPartContainer;
